var React = require('react');

function IconTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm5.664-19.884a7.9 7.9 0 0 0 2.275-1.109 5.594 5.594 0 0 1-1.507 2.66c.038.197.057.399.058.6C21.49 20.6 13.52 24.223 7 20.6a8.433 8.433 0 0 0 5.071-1.449C5.551 16.252 8.45 9.732 8.45 9.732a7.723 7.723 0 0 0 6.52 3.282v-.725a3.246 3.246 0 0 1 5.695-2.173Z","fill":"#fff"}));
}

IconTwitterInline.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = IconTwitterInline;

IconTwitterInline.default = IconTwitterInline;
